export default "__VITE_ASSET__xTvtdiOG__"